import { useGetAuthUserQuery } from "../redux/api/authApiSlice";

export const useAuthUser = () => {
  const { data, isLoading } = useGetAuthUserQuery();
  const user = data?.data;
  return { user, isLoading };
};
